






















































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import { CONSTANTS, EChainStatus, EUserStatus, IChain, IUser, IUserChainRole } from '@zunta/configurations'
import Icon from '@/components/Icon.vue'
import AddChainModal from '../components/AddChainModal.vue'
import Confirm from '@/components/Confirm.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import { ChainModule } from '@/store/modules/chain.module'
import { UserModule } from '@/store/modules/user.module'
import { ETableColumnType, ITableConfig } from '@/interfaces'
import Api from '@/api'
import Card from '@/components/Card.vue'
import Table from '@/components/tables/Table.vue'
import AddSftpUserModal from '@/views/app/admin/components/AddSftpUserModal.vue'
import StatusChain from '@/components/statuses/StatusChain.vue'
import { MODULE_ITEMS } from '@/constants'
import ButtonDownloadReport from '@/components/ButtonDownloadReport.vue'
import DropdownNav from '@/components/DropdownNav.vue'
import { PermissionsModule } from '@/store/modules/permissions.module'

const { SALES_REP_ROLE_NAME } = CONSTANTS

@Component({
  name: 'AdminChains',
  components: {
    DropdownNav,
    ButtonDownloadReport,
    StatusChain,
    Table,
    Card,
    Icon,
    AddChainModal,
    DateTimeLabel,
    Confirm,
    AddSftpUserModal
  }
})
export default class AdminChains extends Vue {
  permissionsModuleInstance: PermissionsModule = getModule(PermissionsModule, this.$store)
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  EChainStatus = EChainStatus
  chainToUpdate: IChain | null = null
  selectedChain: IChain | null = null
  deletableChain: IChain | null = null
  isLoadingReport: boolean = false
  isLoading: boolean = true

  deletingChain: boolean = false
  addingChain: boolean = false
  addingSftpUser: boolean = false
  shouldConfirmDeleteChain: boolean = false

  config: ITableConfig = {
    clearFilterBtn: {
      wrapperClass: 'position-absolute',
      wrapperStyle: 'top: calc(-1rem - 1px); right: -1.5rem;',
      class: 'rounded-bottom'
    },
    useQuery: true,
    usePagination: true,
    rowClick: this.goToChainPage,
    fetchFunction: this.chainModuleInstance.getChainsList,
    columns: [
      {
        minWidth: '200px',
        width: 18,
        key: 'name',
        searchKey: 'name',
        hasSort: true,
        hasSearch: true,
        label: 'Name',
        type: ETableColumnType.default
      },
      {
        class: 'text-left',
        minWidth: '150px',
        width: 12.6,
        key: 'numberOfFacilities',
        searchKey: 'numberOfFacilities',
        hasSort: true,
        hasSearch: true,
        label: 'Number of Facilities',
        type: ETableColumnType.default
      },
      {
        minWidth: '150px',
        width: 8.6,
        key: 'status',
        searchKey: 'status',
        hasSort: true,
        hasSearch: true,
        label: 'Status',
        type: ETableColumnType.select,
        options: [
          {
            key: 'active',
            value: EChainStatus.ACTIVE,
            content: 'Active'
          },
          {
            key: 'inactive',
            value: EChainStatus.NOT_ACTIVE,
            content: 'Inactive'
          }
        ]
      },
      {
        minWidth: '150px',
        width: 12,
        key: 'accountManager',
        searchKey: 'accountManager',
        hasSort: true,
        hasSearch: true,
        label: 'Account Manager',
        type: ETableColumnType.default
      },
      {
        minWidth: '200px',
        width: 12.6,
        key: 'salesRepresentative',
        searchKey: 'salesRepresentativeName',
        hasSort: true,
        hasSearch: true,
        label: 'Sales Rep',
        type: ETableColumnType.default
      },
      {
        minWidth: '120px',
        width: 10.6,
        key: 'createdAt',
        searchKey: 'createdAt',
        hasSort: true,
        hasSearch: true,
        label: 'Date Added',
        type: ETableColumnType.dateRange
      },
      {
        class: '',
        minWidth: '120px',
        width: 12,
        key: 'modules',
        label: 'Modules',
        searchKey: 'modules',
        hasSearch: true,
        type: ETableColumnType.select,
        options: MODULE_ITEMS.map((item) => ({
          value: item.value,
          content: item.content,
          key: item.value
        }))
      },
      {
        class: 'text-right',
        minWidth: '100px',
        width: 6,
        key: 'taskStatus',
        label: 'Task Status',
        hasSearch: false
      },
      {
        class: 'text-left',
        minWidth: '136px',
        maxWidth: '136px',
        width: 12,
        key: 'actions',
        hasSearch: false
      }
    ]
  }

  get chainsList () {
    return this.$store.state.chain.chains
  }

  get chainsTotal () {
    return this.$store.state.chain.total
  }

  get salesReps () {
    return this.$store.state.user.users.filter((user: IUser) => (
      (user.role as IUserChainRole).name === SALES_REP_ROLE_NAME
    ))
  }

  get rolesList () {
    return this.$store.state.permissions.roles
  }

  get dropdownOptions () {
    return (this.rolesList || []).map((role: any) => {
      return {
        key: role.id,
        value: role.id,
        content: role.name
      }
    })
  }

  mounted () {
    this.userModuleInstance.getAdminUsersList({
      limit: 1000,
      status: EUserStatus.ACTIVE
    })
  }

  goToChainPage (item: any) {
    this.$router.push({ name: 'admin-chain-page', params: { id: item.id } })
  }

  async deleteChain () {
    if (!this.deletableChain) {
      return
    }
    this.deletingChain = true
    const response = await this.chainModuleInstance.deleteChain(this.deletableChain.id)
    this.deletingChain = false

    this.closeConfirmDeleteChain()
    if (response === 'OK') {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-success-color)',
        message: 'Process Started',
        header: `Chain Deleting...`,
        icon: 'check'
      })
      return
    }

    this.$eventBus.$emit('notify', {
      color: 'var(--status-error-color)',
      message: 'Process Failed',
      header: `Chain will not be deleted`,
      icon: 'warning'
    })
  }

  async enterAsChain (chain: IChain, roleId?: number) {
    const token = await Api.auth.getChainManagerToken({
      chainId: chain.id,
      roleId: roleId || undefined
    })
    const routeData = this.$router.resolve({
      name: 'management-todo',
      query: {
        token
      }
    })
    this.$locationManager.openNewTab(routeData.href, true)
  }

  openConfirmDeleteChain (chain: IChain) {
    this.deletableChain = chain
    this.shouldConfirmDeleteChain = true
  }

  closeConfirmDeleteChain () {
    this.deletableChain = null
    this.shouldConfirmDeleteChain = false
  }

  openAddChain () {
    this.$router.push({ name: 'admin-create-chain' })
  }

  openAddSftpUSer () {
    this.addingSftpUser = true
  }

  closeAddChain () {
    this.addingChain = false
    this.selectedChain = null
  }

  editChain (chain: IChain) {
    this.selectedChain = chain
    this.addingChain = true
  }

  requestToUpdateStatus (chain: IChain) {
    chain.status === EChainStatus.ACTIVE
      ? this.chainToUpdate = chain
      : this.turn(chain)
  }

  turn (chain: IChain) {
    this.chainToUpdate = null
    const newStatus: EChainStatus = chain.status === EChainStatus.ACTIVE
      ? EChainStatus.NOT_ACTIVE
      : EChainStatus.ACTIVE
    this.chainModuleInstance.updateStatus({
      id: chain.id,
      status: newStatus
    })
  }

  async getChainUserRoles (chain: IChain) {
    this.permissionsModuleInstance.UPDATE_ROLES_LIST([])
    this.isLoading = true
    await this.permissionsModuleInstance.getUserRoles(+chain.id)
    this.isLoading = false
  }
}
